import { render, staticRenderFns } from "./AllContentDashboard.vue?vue&type=template&id=4b8d791a&"
import script from "./AllContentDashboard.vue?vue&type=script&lang=js&"
export * from "./AllContentDashboard.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports